import { render, staticRenderFns } from "./V2ManageTeam.vue?vue&type=template&id=0f871475&scoped=true&"
import script from "./V2ManageTeam.vue?vue&type=script&lang=js&"
export * from "./V2ManageTeam.vue?vue&type=script&lang=js&"
import style0 from "./V2ManageTeam.vue?vue&type=style&index=0&id=0f871475&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f871475",
  null
  
)

export default component.exports